const createCopy = (values = {}) => JSON.parse(JSON.stringify(values));

const createFromKeys = (values = {}) => {
  const result = {};
  Object.keys(values).forEach((key) => (result[key] = ""));
  return result;
};

export const objectHelper = {
  createCopy,
  createFromKeys,
};



// WEBPACK FOOTER //
// ./src/_shared/utils/objectHelper.js